import { render, staticRenderFns } from "./FamiglieArticolo.vue?vue&type=template&id=32487ac0&scoped=true&"
import script from "./FamiglieArticolo.vue?vue&type=script&lang=js&"
export * from "./FamiglieArticolo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32487ac0",
  null
  
)

export default component.exports